import File from "../files/File";

export class Timetable extends File {
    startDate: Date;
    groupId: number;
    groupName: string;
    comments: string;

    get publishedOn(): Date {
        return this.editedOn ?? this.createdOn;
    }

    constructor(data: Partial<Timetable>) {
        super(data);

        this.startDate = data.startDate?.toDate();
        this.comments = data.comments || "";
        this.groupId = data.groupId;
        this.groupName = data.groupName;
    }
}
